import PriorityPatientAPIWorker from '~/utils/workers/priorityPatient.worker?worker'

let worker: Worker

export const fetchPriorityPatient = (type = '') => {
  const config = useRuntimeConfig()
  const userStore = useUserStore()

  const message = {
    base_url: config.public.BACK_URL,
    urls: [`/priority-patients`, '/v2/tasks-counters/patients', '/encounters-counters/patients'],
    token: userStore.token,
    type: type,
  }
  worker.postMessage(JSON.stringify(message))
}

export const initiatePriorityPatientWorker = async () => {
  if (worker) worker?.terminate()
  worker = new PriorityPatientAPIWorker()
  const priorityPatientStore: any = usePriorityPatientsStore()
  const userStore = useUserStore()
  fetchPriorityPatient()

  worker.onmessage = async (event) => {
    if (event.data !== 'error') {
      priorityPatientStore.reloadFromWorker(JSON.parse(event.data))
    } else if (event.data === 'error') {
      const user = await getCurrentUser()
      const token = await user.getIdToken(true)
      userStore.saveFromToken(token)
      await initiatePriorityPatientWorker()
    }
  }
}

export const stopPriorityPatientWebWorker = () => {
  worker?.postMessage(JSON.stringify({ type: 'stop' }))
  worker?.terminate()
}
